import { Component, Input, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { timer } from 'rxjs';
import { CRMReportRequest } from '../crm-data-by-zip-territory.component';
import { customize_lbsap_band_header, DataGridCreatedEvent, excelCustomFormats } from '../crm-report-datagrid/crm-report-datagrid-defns';

@Component({
  selector: 'app-crm-report-current-cust',
  templateUrl: './crm-report-current-cust.component.html',
  styleUrls: ['./crm-report-current-cust.component.scss'],
})
export class CrmReportCurrentCustComponent implements OnInit {

  @Input()
  reportRequest: CRMReportRequest;  

  childDataGrids: Array<DataGridCreatedEvent> = new Array<DataGridCreatedEvent>();

  allsap_heading1: string = 'SAP Sales for the Last Year, All Businesses, All Products (w/ He MRI and Competitors removed)';
  allsap_heading2: string = '';
  allsap_subheading1: string = 'All Industry Segments';

  lbsap_heading1: string = 'SAP LB Sales for the Last Year, N2, O2, Ar, He, H2 (w/ He MRI and Competitors removed)';
  lbsap_heading2: string = '';
  lbsap_subheading1: string = 'All Industry Segments';

  workbook: any;
  excelColMaxWidth = 30;

  constructor() {
  }

  ngOnInit(): void {    
    this.setReportHeadings();    
  }

  setReportHeadings(){    
    this.setReportHeadings_ALLSAP();
    this.setReportHeadings_LBSAP();
  }

  setReportHeadings_ALLSAP(){
    if(this.reportRequest.territoryValue){
      this.allsap_heading2 = 'for ' + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.allsap_heading2 = 'within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }
  }

  setReportHeadings_LBSAP(){
    if(this.reportRequest.territoryValue){
      this.lbsap_heading2 = 'for ' + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.lbsap_heading2 = 'within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }
  }

  async exportExcel(e) {
    
    this.workbook = new Workbook();

    let LBSAP_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'CurrCust_LBSAP');


    if(LBSAP_datagrid_idx >= 0){
      await this.createLBSAP_worksheet(
        this.childDataGrids[LBSAP_datagrid_idx].dataGridComponent,
        this.childDataGrids[LBSAP_datagrid_idx].columnFormatDetails,
        );
    }

    let ALLSAP_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'CurrCust_ALLSAP');

    if(ALLSAP_datagrid_idx >= 0){
      await this.createALLSAP_worksheet(
        this.childDataGrids[ALLSAP_datagrid_idx].dataGridComponent,
        this.childDataGrids[ALLSAP_datagrid_idx].columnFormatDetails,
        );
    }

    await this.workbook.xlsx.writeBuffer()
    .then(function (buffer: BlobPart) {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'cdbSAPCurrent.xlsx');
    });

    e.cancel = true;
    
  }

  async createALLSAP_worksheet(dataGrid: DxDataGridComponent, columnFormatDetails: Array<any>){

    const worksheet = this.workbook.addWorksheet('ALL SAP');

    await exportDataGrid({
      component: dataGrid.instance,
      worksheet: worksheet,
      topLeftCell: { row: 6, column: 1 },
    }).then((cellRange) => {

      //Set default alignment and font properties at the worksheet level
      worksheet.eachRow((row, i) => {
        row.alignment = {
          vertical: 'top',          
          wrapText: true
        }

        row.font = {
          name: 'Arial',
          size: 10
        }
      });            

    }).then(() => {

      //Set format for table header row
      const tableHeaderRow = worksheet.getRow(6);
      
      tableHeaderRow.fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'1C3A70'},
      };                  

      tableHeaderRow.font = { name: 'Arial', size: 10, color: { argb: 'ffffff' }, bold: true };

      //Prepare Sheet header-1
      worksheet.mergeCells('A1:I1');      
      worksheet.getCell('A1').value = {
        'richText': [
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.allsap_heading1 + '\n'},
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.allsap_heading2}
        ]
      };

      worksheet.getCell('A1').alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      }

      worksheet.getRow(1).height = 70;      

      //Prepare Sheet header-2
      worksheet.mergeCells('A3:I3');
      worksheet.getCell('A3').value = {
        'richText': [
          {'font': {'bold': true, 'size': 10,'color': {'argb': '000000'},'name': 'Arial'},'text': this.allsap_subheading1}          
        ]
      };

      //Prepare Sheet header-3
      worksheet.mergeCells('A4:I4');
      worksheet.getCell('A4').value = {
        'richText': [
          {'font': {'bold': false, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': 'The Dollars in the '},
          {'font': {'bold': true, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': 'All SAP Sales'},
          {'font': {'bold': false, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': ' may not exactly match '},
          {'font': {'bold': true, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': 'LB SAP Sales'},
          {'font': {'bold': false, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': ' because:' + '\n'},
          {'font': {'bold': false, 'size': 7,'color': {'argb': '000000'},'name': 'Wingdings'},'text': 'l'},
          {'font': {'bold': true, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': '      LB SAP'},
          {'font': {'bold': false, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': ' page only adds sales where QtyUnit=’KG’\n'},
          {'font': {'bold': false, 'size': 7,'color': {'argb': '000000'},'name': 'Wingdings'},'text': 'l'},
          {'font': {'bold': true, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': '      All SAP'},
          {'font': {'bold': false, 'size': 11,'color': {'argb': '000000'},'name': 'Calibri'},'text': ' page adds any QtyUnit, and there are gas sales dollars where QtyUnit=’KG’ and ‘EA’'},
        ]
      };

      worksheet.getRow(4).height = 50;

      worksheet.getCell('A4').alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      };

      //merge unused header rows
      worksheet.mergeCells('A2:I2');
      worksheet.mergeCells('A5:I5');

      //hide second and fifth row
      worksheet.getRow(2).hidden = true;
      worksheet.getRow(5).hidden = true;

      //Remove borders for header rows
      const no_border_style = {
        top: {style:'thin', color: {argb:'FFFFFF'}},
        left: {style:'thin', color: {argb:'FFFFFF'}},
        bottom: {style:'thin', color: {argb:'FFFFFF'}},
        right: {style:'thin', color: {argb:'FFFFFF'}}
      };      

      const headerRows = worksheet.getRows(1,5);

      headerRows.forEach((row,i) => {         
        row.border = no_border_style;
      });

      //Adjust some column widths
      //worksheet.getColumn('U').width = 25;
      //worksheet.getColumn('Y').width = 28;

      //Reset column widths to max width if they exceed max width
      worksheet.columns.forEach(column => {
        if(column.width > this.excelColMaxWidth){
          column.width = this.excelColMaxWidth;
        }
      });

      //Apply the excel formatting equivalent to what was done in the UI datagrid
      columnFormatDetails.forEach((item,i) => {
        worksheet.getColumn(item.col).numFmt = excelCustomFormats.find(fmt => fmt.gridFmt == item.gridFmt)?.excelFmt;
      });
    });
  }

  async createLBSAP_worksheet(dataGrid: DxDataGridComponent, columnFormatDetails: Array<any>){
    
    const worksheet = this.workbook.addWorksheet('LB SAP');

    await exportDataGrid({
      component: dataGrid.instance,
      worksheet: worksheet,
      topLeftCell: { row: 6, column: 1 },
    }).then((cellRange) => {

      //Set default alignment and font properties at the worksheet level
      worksheet.eachRow((row, i) => {
        row.alignment = {
          vertical: 'top',          
          wrapText: true
        }

        row.font = {
          name: 'Arial',
          size: 10
        }

        row.border = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        };
      });

    }).then(() => {

      //Set format for table header row
      const tableHeaderRow1 = worksheet.getRow(6);
      const tableHeaderRow2 = worksheet.getRow(7);

      tableHeaderRow1.fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'B0C4DE'},
      };                  

      tableHeaderRow1.font = { name: 'Tahoma', size: 10, color: { argb: '000000' }, bold: false };

      tableHeaderRow1.height = 40;
      tableHeaderRow2.height = 30;

      //Prepare Sheet header-1
      worksheet.mergeCells('A1:I1');      
      worksheet.getCell('A1').value = {
        'richText': [
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.lbsap_heading1 + '\n'},
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.lbsap_heading2}
        ]
      };

      worksheet.getCell('A1').alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      }

      worksheet.getRow(1).height = 70;

      //Prepare Sheet header-2
      worksheet.mergeCells('A3:I3');
      worksheet.getCell('A3').value = {
        'richText': [
          {'font': {'bold': true, 'size': 10,'color': {'argb': '000000'},'name': 'Arial'},'text': this.lbsap_subheading1}          
        ]
      };

      //merge unused header rows
      worksheet.mergeCells('A2:I2');
      worksheet.mergeCells('A4:I4');
      worksheet.mergeCells('A5:I5');

      //hide second and fifth row
      worksheet.getRow(2).hidden = true;
      worksheet.getRow(4).hidden = true;
      worksheet.getRow(5).hidden = true;

      //Remove borders for header rows
      const no_border_style = {
        top: {style:'thin', color: {argb:'FFFFFF'}},
        left: {style:'thin', color: {argb:'FFFFFF'}},
        bottom: {style:'thin', color: {argb:'FFFFFF'}},
        right: {style:'thin', color: {argb:'FFFFFF'}}
      };      

      const headerRows = worksheet.getRows(1,5);

      headerRows.forEach((row,i) => {         
        row.border = no_border_style;
      });

      //without these four lines, the column widths are not coming as expected.
      worksheet.getColumn('U').width = 19;
      worksheet.getColumn('V').width = 25;
      worksheet.getColumn('X').width = 25;
      worksheet.getColumn('Z').width = 11;
      worksheet.getColumn('AJ').width = 11;

      //Reset column widths to max width if they exceed max width
      worksheet.columns.forEach(column => {
        if(column.width > this.excelColMaxWidth){
          column.width = this.excelColMaxWidth;
        }
      });

      //Apply the excel formatting equivalent to what was done in the grid
      columnFormatDetails.forEach((item,i) => {
        worksheet.getColumn(item.col).numFmt = excelCustomFormats.find(fmt => fmt.gridFmt == item.gridFmt)?.excelFmt;
      });      

      //For LBSAP report, reformat the product names in the column grouping headers.
      //For eg: N2_KG will be formatted to N2 <line-break> KG
      //Then for the child column headers under each product, apply some formatting. 
      let headerRow1 = worksheet.getRow(6);
      let headerRow2 = worksheet.getRow(7);
      
      headerRow1.eachCell((cell, colNo) => {
        if(colNo >= 27){
          if((cell.value as string).indexOf('_') > 0){
            cell.value = customize_lbsap_band_header(cell.value);
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
              type: 'pattern',
              pattern:'solid',
              fgColor:{argb:'53779F'},
            };
            cell.font = { name: 'Arial', size: 10, color: { argb: 'ffffff' }, bold: true };           
          }
          
          let childHeaderCell = headerRow2.getCell(colNo);
          childHeaderCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          childHeaderCell.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'B0C4DE'},
          };
        }
      });
      

    });
  }

  //Receive datagrid created events and store the event meta-data.
  //This will be used for the export-to-excel functionality
  onDataGridCreated(event: DataGridCreatedEvent){    
    this.childDataGrids.push(event);
  }

}
